export default __webpack_public_path__ + "static/media/e-waste-recycling.6189e240.jpg";